import { render, staticRenderFns } from "./preCode1.vue?vue&type=template&id=05e72d66&scoped=true&"
import script from "./preCode1.vue?vue&type=script&lang=js&"
export * from "./preCode1.vue?vue&type=script&lang=js&"
import style0 from "./preCode1.vue?vue&type=style&index=0&id=05e72d66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e72d66",
  null
  
)

export default component.exports